import { useMemo } from 'react';
import { EntityName, useEntitySecurityPath } from '../../../auth/Security';
import { resolveEntityDeepLinkUIStatePath } from './useEntityDeepLinkUIStatePath.utils';

export { resolveEntityDeepLinkUIStatePath };

/**
 * Hook to get the Deep Link UI State Path for a given entity.
 * The resolved path is based on the current location in the EntitySecurityProvider hierarchy.
 *
 * @param entity Entity name for which to make the Deep Link UI State Path
 * @param entityDeepLinkUIStatePath An optional override for the Deep Link UI State Path.
 * @returns The resolved Deep Link UI State Path as a string.
 */
export const useEntityDeepLinkUIStatePath = (entity: EntityName, entityDeepLinkUIStatePath?: string): string => {
    const entityDeepLinkBaseUIStatePath = useEntitySecurityPath();

    const resolvedEntityDeepLinkUIStatePath = useMemo(() => {
        return resolveEntityDeepLinkUIStatePath(entity, entityDeepLinkUIStatePath, entityDeepLinkBaseUIStatePath);
    }, [entity, entityDeepLinkUIStatePath, entityDeepLinkBaseUIStatePath]);

    return resolvedEntityDeepLinkUIStatePath;
};
